import { Box } from "@mui/joy";
import React from "react";
import { centrado } from "../utils/Estilos";
import nosotros from "../assets/banner/nosotrosp.jpg";
import { Grid2, Typography } from "@mui/material";
import { Helmet } from "react-helmet";

export const Privacidad = () => {
  return (
    <Box sx={{ ...centrado, width: "100%", flexWrap: "wrap" }}>
      <Helmet>
        <title>{"Publimed Store - Política de Privacidad"}</title>
      </Helmet>
      <Box
        sx={{
          backgroundImage: "url(" + nosotros + ")",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
          height: "400px",
          width: "100%",
        }}
      />
      <Grid2 container sx={{ width: "80%", ...centrado }} py={2}>
        <Grid2 size={{ xs: 12, md: 10 }} sx={{ padding: "20px" }}>
          <Typography variant="h5" fontWeight={"bold"} color="primary" pt={5}>
            Privacy Policy
          </Typography>
          <Typography variant="h6" pt={5}>
            This Privacy Policy describes how your personal information is
            collected, used, and shared when you visit or make a purchase from
            publimed.net.
          </Typography>
          <Typography variant="h6" pt={2}>
            Personal Information We Collect: When you make a purchase, we
            collect certain information from you, including your name, billing
            address, payment information, and email address.
          </Typography>
          <Typography variant="h6" pt={2}>
            How Do We Use Your Personal Information?: We use the Order
            Information that we collect generally to fulfill any orders placed
            through the Site (including processing your payment information and
            providing you with invoices and/or order confirmations).
          </Typography>
          <Typography variant="h6" pt={2}>
            Data Retention: When you place an order through the Site, we will
            maintain your Order Information for our records unless and until you
            ask us to delete this information.
          </Typography>
          <Typography variant="h6" pt={2}>
            Security: We take reasonable precautions and follow industry best
            practices to make sure your personal information is not
            inappropriately lost, misused, accessed, or disclosed.
          </Typography>
        </Grid2>
      </Grid2>
    </Box>
  );
};
